import { __assign } from "tslib";
import { createBrandingApi, brandingRelativePath, hcCustomFontRelativePath } from './';
import { createFakeGetResponder, createFakePutResponder, createFakePostResponder } from '../../../test-utils';
import { createHttpTestKit } from '../../../http/test-kit';
export var createBrandingApiTestKit = function () {
    var fakeHttp = createHttpTestKit();
    var api = createBrandingApi('', fakeHttp);
    var testKit = {
        whenGet: function (dto) {
            var url = brandingRelativePath(dto.locale, dto.brandId);
            return createFakeGetResponder(fakeHttp, url);
        },
        whenUpdateBranding: function (dto, locale) {
            var url = "" + brandingRelativePath(locale);
            return createFakePutResponder(fakeHttp, url)(dto);
        },
        whenGetCustomFontDataByUrl: function (dto) {
            var fontUrl = dto.fontUrl;
            return createFakePostResponder(fakeHttp, "" + dto.tenantDefaultHost + hcCustomFontRelativePath)({ fontUrl: fontUrl });
        }
    };
    return __assign(__assign({}, api), testKit);
};
//# sourceMappingURL=testkit.js.map